import { Typography as LyfeTypography } from "@lyfegen-platform/react-common";
import { Box, Divider, Switch, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FlexSectionController } from "../../models/flexible/flex-section-controller";

function DividerHeader() {
	const {
		palette,
		typography: { pxToRem },
	} = useTheme();

	return (
		<Divider
			style={{
				flexGrow: 1,
				margin: pxToRem(15),
				backgroundColor: palette.widgetHeaderText.main,
			}}
		/>
	);
}

function SwitchHeader(props: { controller: FlexSectionController; isOpen?: boolean; handleSwitchState?: () => void }) {
	const isDisabled = props.controller.useIsSectionSwitchDisabled?.() ?? false;
	const processHasChanged = props.controller.useProcessSectionStateChange?.();

	function handleSwitchChange() {
		const newState = !props.isOpen;
		processHasChanged?.(newState);
		props.handleSwitchState?.();
	}

	return (
		<Box ml={3}>
			<Switch disabled={isDisabled} checked={!!props.isOpen} color="primary" onChange={handleSwitchChange} />
		</Box>
	);
}

export function SectionHeader(props: {
	localizableKey?: string;
	controller?: FlexSectionController;
	isOpen?: boolean;
	handleSwitchState?: () => void;
}) {
	const { t } = useTranslation();
	const { palette } = useTheme();
	const isDividerUsed = !props.controller || !props.controller.schema.isOptional || !props.controller.context.isEditable;

	return (
		<Box width="100%" display="flex" justifyContent={isDividerUsed ? "space-between" : undefined} alignItems="center">
			<LyfeTypography noWrap type="h7" style={{ color: palette.widgetHeaderText.main }}>
				{t(props.controller?.schema.localizableKey || props.localizableKey || "")}
			</LyfeTypography>
			{isDividerUsed ? (
				<DividerHeader />
			) : (
				<SwitchHeader controller={props.controller!} isOpen={props.isOpen} handleSwitchState={props.handleSwitchState} />
			)}
		</Box>
	);
}
